import {
  loginURL,
  registerURL,
  doctorSpecialityUrl,
  socket,
  startSocket,
  GenerateOtpApiURL,
  verifyOtpURL,
  logoutUrl,
  postFcmTokenURL,
  loginEmailURL,
  resetPasswordURL,
  verifyResetOtpURL,
  resetPasswordOtpURL
} from '../constants';
import { toast } from 'react-toastify';
import { headers } from 'src/utils';
import { GetApi, PostApi } from 'src/services/middleware';
import { fetchDoctorProfileRequest } from './profile';

// login api
export const authLogin = async (
  mobile,
  token,
  navigation,
  getNotificationData
) => {
  try {
    const res = await PostApi(`${loginURL}`, {
      mobile,
      token
    });
    if (res.status == 200) {
      localStorage.setItem('doctorId', res?.data?.data?.doctor_id);
      localStorage.setItem('token', res?.data?.data?.token);
      localStorage.setItem('uid', token);
      localStorage.setItem('mobile', mobile);
      localStorage.setItem(
        'approved',
        res?.data?.data?.approved || res?.data?.data?.verified
      );
      localStorage.setItem('user_id', res?.data?.data?.user);
      if (res?.data?.data?.doctor_specialty) {
        localStorage.setItem(
          'doctor_specialty',
          res?.data?.data?.doctor_specialty
        );
      }
      if (res?.data?.data?.permission) {
        localStorage.setItem(
          'permission',
          JSON.stringify(res?.data?.data?.permission)
        );
      }
      localStorage.setItem('isPdf', res?.data?.data?.data?.generate_pdf);
      if (res?.data?.data?.user_roles) {
        localStorage.setItem(
          'user_roles',
          JSON.stringify(res?.data?.data?.user_roles)
        );
      }
      const isRegistered = res?.data?.data?.registered || false;
      const isVerified = res?.data?.data?.verified || false;
      if (!socket || res?.data?.data?.doctor_id) {
        startSocket(
          res?.data?.data?.doctor_id,
          navigation,
          getNotificationData
        );
      }
      if (isRegistered) {
        navigation.push('/');
      }

      if (!isRegistered && !isVerified) {
        navigation.push('/signup');
      }
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

// doctor register api
export const doctorRegister = async (data, is_last, navigation) => {
  try {
    const res = await PostApi(`${registerURL}`, data, headers());
    if (res.status == 200) {
      if (is_last) {
        navigation.push('/approval');
      }
      toast.success('Profile details saved');
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

// fetch doctor specialities
export const doctorSpeciality = async () => {
  try {
    const res = await GetApi(`${doctorSpecialityUrl}`, headers());
    if (res.status == 200) {
      return res.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

// doctor generate Otp api
export const generateOtpFunction = async (data) => {
  try {
    const res = await PostApi(`${GenerateOtpApiURL}`, data);
    if (res.status == 200) {
      return res.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};
// doctor verify Otp api
export const verifyOtpFunction = async (
  data,
  navigation,
  getNotificationData,
  dispatch,
  setConfirmation,
  isFromRegister = false
) => {
  try {
    const res = await PostApi(`${verifyOtpURL}`, data);
    if (res.status == 200) {
      const responseData = res.data?.data;

      const isRegistered = responseData?.registered || false;
      const approved = responseData?.approved || false;

      // Check if coming from register page and user already exists
      if (isFromRegister && navigation) {
        if (approved) {
          toast.success('User already exist. Please login!');
          localStorage.clear();
          navigation.push('/login');
          return;
        }
      }

      if (!approved && isRegistered) {
        toast.info('Verification pending!');
        localStorage.clear();
        setConfirmation(false);
        return;
      }
      dispatch(
        fetchDoctorProfileRequest({
          ...responseData?.doctor_data,
          ...responseData?.doctor_data?.user
        })
      );

      if (!isRegistered) {
        navigation.push('/signup');
      }
      // Store all necessary data in localStorage
      if (responseData?.doctor_id) {
        localStorage.setItem('doctorId', responseData.doctor_id);
      }
      if (responseData?.token) {
        localStorage.setItem('token', responseData.token);
      }
      if (responseData?.['Auth-Token']) {
        localStorage.setItem('auth_token', responseData['Auth-Token']);
      }
      if (data.token) {
        localStorage.setItem('uid', data.token);
      }
      if (data.mobile) {
        localStorage.setItem('mobile', data.mobile);
      }
      if (
        responseData?.approved !== undefined ||
        responseData?.verified !== undefined
      ) {
        localStorage.setItem(
          'approved',
          responseData.approved || responseData.verified
        );
      }
      if (responseData?.user) {
        localStorage.setItem('user_id', responseData.user);
      }
      if (responseData?.doctor_specialty) {
        localStorage.setItem('doctor_specialty', responseData.doctor_specialty);
      }
      if (responseData?.permission) {
        localStorage.setItem(
          'permission',
          JSON.stringify(responseData.permission)
        );
      }
      if (responseData?.data?.generate_pdf) {
        localStorage.setItem('isPdf', responseData.data.generate_pdf);
      }
      if (responseData?.user_roles) {
        localStorage.setItem(
          'user_roles',
          JSON.stringify(responseData.user_roles)
        );
      }

      // Start socket connection
      if (
        (!socket || responseData?.doctor_id) &&
        navigation &&
        getNotificationData
      ) {
        startSocket(responseData.doctor_id, navigation, getNotificationData);
      }

      // Navigate based on registration status
      if (navigation) {
        if (isRegistered) {
          navigation.push('/');
        }
      }

      if (navigation) {
        if (isRegistered && approved && isFromRegister) {
          toast.success('User already exist. Please login!');
          localStorage.clear();
          navigation.push('/login');
        }
      }

      return res.data;
    }
  } catch (err) {
    console.error(err, 'something went wrong');
  }
};

// doctor logout
export const doctorLogout = async (data) => {
  try {
    const res = await PostApi(`${logoutUrl}`, data, headers());
    return res;
  } catch (err) {
    toast.error('something went wrong');
  }
};

// user fcm  token post
export const postFcmToken = async (data) => {
  try {
    const res = await PostApi(`${postFcmTokenURL}`, data, headers());
    if (res.status === 200) {
      return res;
    }
  } catch (err) {
    // toast.error('something went wrong');
  }
};

export const emailLogin = async (data, navigation, dispatch) => {
  try {
    const res = await PostApi(`${loginEmailURL}`, data);
    if (res.status == 200) {
      const responseData = res.data?.data;
      dispatch(
        fetchDoctorProfileRequest({
          ...responseData?.doctor_data,
          ...responseData?.doctor_data?.user
        })
      );
      localStorage.setItem('auth_token', responseData?.['Auth-Token']);
      const isRegistered = responseData?.registered || false;
      const approved = responseData?.approved || false;
      if (!approved && isRegistered) {
        toast.info('Verification pending!');
        localStorage.clear();
        return;
      }

      if (!isRegistered) {
        navigation.push('/signup');
      }
      // Store all necessary data in localStorage
      if (responseData?.doctor_id) {
        localStorage.setItem('doctorId', responseData.doctor_id);
      }
      if (responseData?.token) {
        localStorage.setItem('token', responseData.token);
      }
      if (data.token) {
        localStorage.setItem('uid', data.token);
      }
      if (data.mobile) {
        localStorage.setItem('mobile', data.mobile);
      }
      if (
        responseData?.approved !== undefined ||
        responseData?.verified !== undefined
      ) {
        localStorage.setItem(
          'approved',
          responseData.approved || responseData.verified
        );
      }
      if (responseData?.user) {
        localStorage.setItem('user_id', responseData.user);
      }
      if (responseData?.doctor_specialty) {
        localStorage.setItem('doctor_specialty', responseData.doctor_specialty);
      }
      if (responseData?.permission) {
        localStorage.setItem(
          'permission',
          JSON.stringify(responseData.permission)
        );
      }
      if (responseData?.data?.generate_pdf) {
        localStorage.setItem('isPdf', responseData.data.generate_pdf);
      }
      if (responseData?.user_roles) {
        localStorage.setItem(
          'user_roles',
          JSON.stringify(responseData.user_roles)
        );
      }

      // Navigate based on registration status
      if (navigation) {
        if (isRegistered) {
          navigation.push('/');
        }
      }

      return res.data;
    }
  } catch (err) {
    toast.error('Invalid email or password');
  }
};

export const sendResetOtp = async (data) => {
  try {
    const res = await PostApi(`${resetPasswordOtpURL}`, data);
    if (res.status == 200) {
      return res.data;
    }
  } catch (err) {
    console.error(err, 'something went wrong');
  }
};

export const verifyResetOtp = async (data) => {
  try {
    const res = await PostApi(`${verifyResetOtpURL}`, data);
    if (res.status == 200) {
      return res.data;
    }
  } catch (err) {
    console.error(err, 'something went wrong');
  }
};

export const resetPasswordFunction = async (data) => {
  try {
    const res = await PostApi(`${resetPasswordURL}`, data);
    return res.data;
  } catch (err) {
    toast.error('Failed to reset password');
    throw err;
  }
};
